import 'virtual:uno.css';
import 'animate.css';

import '@fortawesome/fontawesome-free/scss/fontawesome.scss';
import '@fortawesome/fontawesome-free/scss/brands.scss';
import 'bootstrap-icons/font/bootstrap-icons.scss';
import 'bootstrap/scss/bootstrap.scss';
import './assets/css/main.scss';
import './assets/css/responsive.scss';

import { createApp, ref } from 'vue';
import { createPinia } from 'pinia'
import App from './App.vue';
import router from './router';

import 'lazysizes';

const app = createApp(App);
const appLoading = ref(false);

app.provide('app-loading', appLoading);

app.use(createPinia());
app.use(router);

router.isReady().then(() => {
  const cursor = document.querySelector<HTMLElement>('#cursor');
  const cursorInner = document.querySelector<HTMLElement>('#cursor2');

  if (cursor && cursorInner) {
    document.addEventListener('mousemove', (e) => {
      cursor.style.transform = `translate3d(calc(${e.clientX}px - 50%), calc(${e.clientY}px - 50%), 0)`;
    });

    document.addEventListener('mousemove', (e) => {
      const x = e.clientX;
      const y = e.clientY;

      cursorInner.style.left = x + 'px';
      cursorInner.style.top = y + 'px';
    });

    document.addEventListener('mousedown', () => {
      cursor.classList.add('click');
      cursorInner.classList.add('cursorinnerhover');
    });

    document.addEventListener('mouseup', () => {
      cursor.classList.remove('click');
      cursorInner.classList.remove('cursorinnerhover');
    });
  }

  app.mount('#app');

  const element = document.querySelector('#preloader');
  element?.classList.add('animate__animated', 'animate__fadeOut');

  element?.addEventListener('animationend', () => {
    element.remove();
  });
});
